import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../../models/work-item';
import { WorkMenuEvent } from '../../../events/work-menu-event';
import { UIMenuModel } from 'e5core-angular-services';

@Component({
  selector: 'e5core-ui-work-menu-item-material',
  templateUrl: './e5core-ui-work-menu-item-material.component.html',
  styleUrls: ['./e5core-ui-work-menu-item-material.component.css']
})
export class E5coreUiWorkMenuItemMaterialComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() menuItem: UIMenuModel ;
  @Output() clickEvent = new EventEmitter<WorkMenuEvent>() ;

  constructor() { }

  ngOnInit() {
  }

  onClick($event, menuCode) {
    this.clickEvent.emit({$event: $event, menuCode: menuCode}) ;
  }

  mapIcon(code: string) {
    switch (code.toLowerCase()) {
      case 'saveandclose' : return 'close' ;
      case 'diarise' : return 'date_range' ;
      case 'complete' : return 'assignment_turned_in' ;
      case 'endgetnext' : return 'stop' ;
      case 'clonewithoptions' : return 'file_copy' ;
      case 'reject' : return 'highlight_off' ;
    }
    return (code) ;
  }

}
